/* This is the EMIS Classes for secondary school components */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table width="800px;" border="1px;" cellspacing="0px;">
        <tbody>
          <!-- title row -->
          <tr>
            <td class="row-title">ថ្នាក់រៀន</td>
            <td class="row-data">ថ្នាក់ទី ១</td>
            <td class="row-data">ថ្នាក់ទី ២</td>
            <td class="row-data">ថ្នាក់ទី ៣</td>
            <td class="row-data">ថ្នាក់ទី ៤</td>
            <td class="row-data">ថ្នាក់ទី ៥</td>
            <td class="row-data">ថ្នាក់ទី ៦</td>
            <td class="row-data">សរុប</td>
          </tr>
          <!-- 1st row -->
          <tr>
            <td class="row-title">ចំនួនថ្នាក់រៀន</td>
            <td
              v-for="(value, col) in data[0].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[0].dt[col]" class="number" />
            </td>
            <td class="row-data">
              <strong>{{ row }}</strong>
            </td>
          </tr>

          <!-- 2nd row -->          
          <tr>
            <td class="row-title">ចំនួនបន្ទប់រៀន</td>
            <td
              v-for="(value, col) in data[1].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[1].dt[col]" class="number" />
            </td>
            <td class="row-data">
              <strong>{{ row1 }}</strong>
            </td>
          </tr>
          
          <!-- 3rd row -->          
          <tr>
            <td class="row-title">ចំនួនគ្រូបង្រៀនតាមថ្នាក់</td>
            <td
              v-for="(value, col) in data[2].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[2].dt[col]" class="number" />
            </td>
            <td class="row-data">
              <strong>{{ row2 }}</strong>
            </td>
          </tr>          
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  computed: {
    row: function () {
      let d = this.data[0].dt;
      return (
        Number(d[0]) +
        Number(d[1]) +
        Number(d[2]) +
        Number(d[3]) +
        Number(d[4]) +
        Number(d[5])
      );
    },    
    row1: function () {
      let d = this.data[1].dt;
      return (
        Number(d[0]) +
        Number(d[1]) +
        Number(d[2]) +
        Number(d[3]) +
        Number(d[4]) +
        Number(d[5])
      );
    },
    row2: function () {
      let d = this.data[2].dt;
      return (
        Number(d[0]) +
        Number(d[1]) +
        Number(d[2]) +
        Number(d[3]) +
        Number(d[4]) +
        Number(d[5])
      );
    },  
  },
};
</script>

<style scoped>
.number {
  width: 90px;
  text-align: center;
}
.row-data {
  width: 90px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-title {
  width: 170px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
}
</style>